import { render, staticRenderFns } from "./CourseSensors.html?vue&type=template&id=bb0d7a16&scoped=true&external"
import script from "./CourseSensors.vue?vue&type=script&lang=js"
export * from "./CourseSensors.vue?vue&type=script&lang=js"
import style0 from "./CourseSensors.scss?vue&type=style&index=0&id=bb0d7a16&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0d7a16",
  null
  
)

export default component.exports